import Vue from "vue";
import Vuex, {Payload, Store} from "vuex";
import VuexPersistence from "vuex-persist";
import Cookies from "js-cookie";
import IdleVue from "idle-vue"
import summary from '@store/v1/modules/summary'
import application from '@store/v1/modules/application'
import commercial from "@store/v1/modules/commercial"
import applicant from '@store/v1/modules/applicant'
import documents from '@store/v1/modules/documents'
import loanDetails from '@store/v1/modules/loan-details'
import statusIndicators from '@store/v1/modules/status-indicators'
import options from '@store/v1/modules/options'
import user_roles from '@store/v1/modules/user_roles'
import notes from '@store/v1/modules/notes'
import user from '@store/v1/modules/user'
import preliminaryAssessment from '@store/v1/modules/preliminary-assessment'
import Tenant from '@store/v1/modules/tenant'
import workspace from '@store/v1/modules/workspace'
import invoice from '@store/v1/modules/invoice'
import referrer from '@store/v1/modules/referrer'
import referrers from '@store/v1/modules/referrers'
import signature from '@store/v1/modules/signature'
import applicantEmail from '@store/v1/modules/applicant_email'
import loanOptions from '@store/v1/modules/loan_options'
import emailForwards from '@store/v1/modules/email_forwards'
import ds from '@store/v1/modules/ds'
import sharedExpense from '@store/v1/modules/preliminary_assesments/shared_expenses'
import sms from '@store/v1/modules/sms'
import hems from "@store/v1/modules/hems";
import tenant from "@shared/lib/Http.js"

// insurance deals
import InsuranceDealsOption from "@store/v1/modules/insurance_deals/options";
import InsuranceDealsApplication from "@store/v1/modules/insurance_deals/application";
import InsuranceDealsInsurance from "@store/v1/modules/insurance_deals/insurance";
import InsuranceDealsDocuments from "@store/v1/modules/insurance_deals/documents";
import InsuranceDealsValidation from "@store/v1/modules/insurance_deals/validation";
import InsuranceDealsTemplate from "@store/v1/modules/insurance_deals/template";

import apiValidation from "@store/v1/modules/api-validation";

import chat from "@store/v1/modules/chat/chat";
import userSettings from "@store/v1/modules/userSettings/userSettings"

import ambition from "@store/v1/modules/ambition/ambition"
import applicationsDashboard from "@store/v1/modules/applicationsDashboard"

// Ambition v2.0 – Core vuex module for $store2 API
import store2 from '@store/v2'

// Ambition v2.0 – New normal vuex modules for v2.0 refactor
// import store2Modules from '@store/v2/modules'
import SendAndSettle from '@store/v2/modules/SendAndSettle'
import MergeAndMarkup from '@store/v2/modules/MergeAndMarkup'


import builderEmail from '@store/v1/modules/builderEmail'
import ticketEmail from "@shared/components/Ticket/Email/store/ticketEmail"
import zapier from '@store/v1/modules/zapier'
import applicationValidation from '@store/v1/modules/applicationValidation'
import applicationAudit from '@store/v1/modules/applicationAudit'
import notifications from "@store/v1/modules/notifications"

import tasks from "@store/v1/modules/tasks"

import insuranceDocuments from "@store/v1/modules/insuranceDocuments"
import deferredInsurance from "@store/v1/modules/deferredInsurance"

import appTabLayout from "@store/v1/modules/appTabLayout"
import insurance from "@store/v1/modules/insurance"
import documentLibrary from "@store/v1/modules/documentLibrary"

// Vuex Basement
import basement from './basement'


// Form Component Store
import formComponent from "@shared/components/CustomFormBuilder/formComponent/store"
import {_} from "core-js";

// Store v3
import appStoreModule from '@tenant/app/store'

// custom form builder store
import formBuilderStore from '@shared/components/CustomFormBuilder/store'
import formStore from "@tenant/app-form/store"

Vue.use(Vuex)

const vuexPersistTenant = new VuexPersistence({
    restoreState: (key, storage) => Cookies.getJSON(key),
    saveState: (key, state, storage) => Cookies.set(key, state),
    modules: ["Tenant"],
    filter: mutation => mutation.type === "Tenant/setAccessToken"
})

const store = new Store({
    plugins: [vuexPersistTenant.plugin],
    modules: Object.assign(
        {},
        {
            // app store
            ...appStoreModule,
            // form builder store
            ...formBuilderStore,
            // form store
            formStore: formStore,

            // $store2 requires a custom vuex module, this module is intended for use by the $store2 API only.
            store2,

            // Custom modules for Ambition v2.0, these can be used like the normal old modules below.
            SendAndSettle,
            MergeAndMarkup,
            applicationsDashboard,
            Tenant,
            summary,
            application,
            commercial,
            applicant,
            documents,
            loanDetails,
            statusIndicators,
            options,
            user_roles,
            user,
            notes,
            preliminaryAssessment,
            workspace,
            invoice,
            referrer,
            referrers,
            signature,
            applicantEmail,
            loanOptions,
            emailForwards,
            ds,
            sharedExpense,
            InsuranceDealsOption,
            InsuranceDealsApplication,
            InsuranceDealsInsurance,
            InsuranceDealsDocuments,
            InsuranceDealsValidation,
            InsuranceDealsTemplate,
            apiValidation,
            sms,
            hems,
            chat,
            userSettings,
            builderEmail,
            ticketEmail,
            zapier,
            applicationValidation,
            ambition,
            applicationAudit,
            notifications,
            tasks,
            insuranceDocuments,
            appTabLayout,
            deferredInsurance,
            insurance,
            documentLibrary,
            ...formComponent,
        }
    ),
    state: {
        token: "",
        adminToken: "",
        adminSettings: {},
        appId: "",
        editLock: null,
        editLockUser: null,
        initAppData: {},
        first_name: "",
        middle_name: "",
        broker_id: "",
        last_name: "",
        phone: "",
        home_phone: "",
        email: "",
        email2: "",
        use_alias: false,
        client_id: null, // applicant from summary
        referrers: [],
        adminReferrerUsers: [],
        permissions: [],
        timezone: "",
        assetInfo: {},
        canEditCompleted: "",
        enableDigitalAncillaries: false,
        enableMonthlyFrequencyForExpenses: false,
        pendingSave: false,
        requestPrivacyConsentModalSaving: false,
        isWithEquifax: false,
        loanTierFilters: {
            vedascore_comprehensive: "",
            vedascore_negative_2_0: "",
            vedascore_negative_1_1: "",
            onescore: "",
        }
    },
    mutations: {
        updateAppStatus(state, val) {
            state.initAppData.status = val
        },
        updateAppStatusId(state, statusId) {
            state.initAppData.application_status_id = statusId
        },
        saveEnableDigitalAncillaries(state, val) {
            state.enableDigitalAncillaries = val
        },
        saveEnableMonthlyFrequencyForExpenses(state, val) {
            state.enableMonthlyFrequencyForExpenses = val
        },
        updateEditLock(state, val) {
            state.editLock = val
        },
        updateEditLockUser(state, val) {
            state.editLockUser = val
        },
        saveCanEditCompleted(state, val) {
            state.canEditCompleted = val
        },
        saveToken(state, token) {
            state.token = token
        },
        saveAdminToken(state, token) {
            state.adminToken = token
        },
        saveAdminSettings(state, adminSettings) {
            state.adminSettings = adminSettings
        },
        saveAppId(state, id) {
            state.appId = id
        },
        saveAppData(state, appData) {
            state.initAppData = {...state.initAppData, ...appData}
            state.editLock = _.get(appData, "edit_lock")
        },
        saveSourceId(state, source_id) {
            state.initAppData.source_id = source_id
        },
        // Save summary page personal details
        saveFirstName(state, name) {
            if (!_.isEmpty(state.initAppData.applicants)) {
                state.initAppData.applicants[0].first_name = name
            } else {
                state.first_name = name
            }
        },
        saveMiddleName(state, name) {
            if (!_.isEmpty(state.initAppData.applicants)) {
                state.initAppData.applicants[0].middle_name = name
            } else {
                state.middle_name = name
            }
        },
        saveLastName(state, name) {
            if (!_.isEmpty(state.initAppData.applicants)) {
                state.initAppData.applicants[0].last_name = name
            } else {
                state.last_name = name
            }
        },
        savePhone(state, phone) {
            if (!_.isEmpty(state.initAppData.applicants)) {
                state.initAppData.applicants[0].phone = phone
            } else {
                state.phone = phone
            }
        },
        saveHomePhone(state, phone) {
            if (!_.isEmpty(state.initAppData.applicants)) {
                state.initAppData.applicants[0].home_phone = phone
            } else {
                state.home_phone = phone
            }
        },
        saveEmail(state, email) {
            if (!_.isEmpty(state.initAppData.applicants)) {
                state.initAppData.applicants[0].email = email
            } else {
                state.email = email
            }
        },
        saveEmail2(state, email) {
            if (!_.isEmpty(state.initAppData.applicants)) {
                state.initAppData.applicants[0].email2 = email
            } else {
                state.email2 = email
            }
        },
        saveNoOfApplicants(state, number) {
            state.initAppData.no_of_applicants = number
        },
        saveAdminReferrerUsers(state, users) {
            state.adminReferrerUsers = users
        },
        savePermissions(state, permissions) {
            state.permissions = permissions
        },
        saveTimezone(state, timezone) {
            state.timezone = timezone
        },
        saveAssetInfo(state, info) {
            state.assetInfo = info
        },
        saveBrokerId(state, id) {
            state.broker_id = id
        },
        saveSellerTypeId(state, id) {
            state.initAppData.seller_type_id = Number(id)
        },
        pendingSave(state, pending) {
            state.pendingSave = pending
        },
        requestPrivacyConsentModalSaving(state, saving) {
            state.requestPrivacyConsentModalSaving = saving
        },
        updateLoanTierFilters(state, data) {
            state.loanTierFilters.vedascore_comprehensive = data.vedascore_comprehensive
            state.loanTierFilters.vedascore_negative_2_0 = data.vedascore_negative_2_0
            state.loanTierFilters.vedascore_negative_1_1 = data.vedascore_negative_1_1
            state.loanTierFilters.onescore = data.onescore
        },
    },
    actions: {
        // Vuex Basement
        "global commit": basement.global_commit,
        updateAppStatus(context, appData) {
            context.commit("updateAppStatus", appData)
        },
        updateAppStatusId(context, statusId) {
            context.commit("updateAppStatusId", statusId)
        },
        updateEditLock(context, usedId) {
            context.commit("updateEditLock", usedId)
        },
        updateEditLockUser(context, usedId) {
            context.commit("updateEditLockUser", usedId)
        },
        saveEnableDigitalAncillaries(context, value) {
            context.commit("saveEnableDigitalAncillaries", value)
        },
        saveEnableMonthlyFrequencyForExpenses(context, value) {
            context.commit("saveEnableMonthlyFrequencyForExpenses", value)
        },
        saveCanEditCompleted(context, value) {
            context.commit("saveCanEditCompleted", value)
        },
        saveToken(context, token) {
            context.commit("saveToken", token)
        },
        saveAdminToken(context, token) {
            context.commit("saveAdminToken", token)
        },
        saveAdminSettings(context, adminSettings) {
            context.commit("saveAdminSettings", adminSettings)
        },
        saveAppId(context, id) {
            context.commit("saveAppId", id)
        },
        saveAppData(context, appData) {
            context.commit("saveAppData", appData)
        },
        saveSourceId(context, source_id) {
            context.commit("saveSourceId", source_id)
        },
        // Save summary page personal details
        saveFirstName(context, name) {
            context.commit("saveFirstName", name)
        },
        saveMiddleName(context, name) {
            context.commit("saveMiddleName", name)
        },
        saveLastName(context, name) {
            context.commit("saveLastName", name)
        },
        savePhone(context, phone) {
            context.commit("savePhone", phone)
        },
        saveHomePhone(context, phone) {
            context.commit("saveHomePhone", phone)
        },
        saveEmail(context, email) {
            context.commit("saveEmail", email)
        },
        saveEmail2(context, email) {
            context.commit("saveEmail2", email)
        },
        saveNoOfApplicants(context, number) {
            context.commit("saveNoOfApplicants", number)
        },
        savePermissions(context, permissions) {
            context.commit("savePermissions", permissions)
        },
        saveTimezone(context, timezone) {
            context.commit("saveTimezone", timezone)
        },
        saveAdminReferrerUsers(context, users) {
            context.commit("saveAdminReferrerUsers", users)
        },
        saveAssetInfo(context, info) {
            context.commit("saveAssetInfo", info)
        },
        saveBrokerId(context, id) {
            context.commit("saveBrokerId", id)
        },
        saveSellerTypeId(context, id) {
            context.commit("saveSellerTypeId", Number(id))
        },
        syncApplication(context) {
            return new Promise((resolve, reject) => {
                tenant
                    .post(`/admin/application/get-application`, {
                        applicationId: $store.getters.appId,
                    })
                    .then((res) => {
                        const {data} = res
                        context.commit("saveAppData", data)
                        $store.dispatch("appStore/application/set", data)
                        resolve(res)
                    })
                    .catch((err) => {
                        reject(err)
                        err.output()
                    })
                    .finally(() => {
                        setTimeout(() => {
                            Vue.prototype.$bus.$emit("bulkUpdate")
                        }, 2000)
                    })
            })
        },
        pendingSave(context, pending) {
            context.commit("pendingSave", pending)
        },
        requestPrivacyConsentModalSaving(context, saving) {
            context.commit("requestPrivacyConsentModalSaving", saving)
        },
        updateLoanTierFilters(context, data) {
            context.commit("updateLoanTierFilters", data)
        },
    },
    getters: {
        enableDigitalAncillaries: (state) => state.enableDigitalAncillaries,
        enableMonthlyFrequencyForExpenses: (state) => state.enableMonthlyFrequencyForExpenses,
        canEditCompleted: (state) => state.canEditCompleted,
        token: (state) => state.token,
        editLock: (state) => state.editLock,
        editLockUser: (state) => state.editLockUser,
        adminToken: (state) => state.adminToken,
        adminSettings: (state) => state.adminSettings,
        appId: (state) => {
            if (state.initAppData) {
                return state.initAppData.id
            }
            return state.appId
        },
        hems: (state) => state.hems,
        initAppData: (state) => state.initAppData,
        first_name: (state) => state.first_name,
        middle_name: (state) => state.middle_name,
        last_name: (state) => state.last_name,
        phone: (state) => state.phone,
        homePhone: (state) => state.home_phone,
        email: (state) => state.email,
        email2: (state) => state.email2,
        adminReferrerUsers: (state) => state.adminReferrerUsers,
        permissions: (state) => state.permissions,
        timezone: (state) => state.timezone,
        assetInfo: (state) => state.assetInfo,
        broker_id: (state) => state.broker_id,
        seller_type_id: (state) => state.initAppData.seller_type_id,
        pendingSave: (state) => state.pendingSave,
        requestPrivacyConsentModalSaving: (state) => state.requestPrivacyConsentModalSaving,
        loanTierFilters: (state) => state.loanTierFilters,
    },
})

basement.attach_to_store(store)

/**
 *
 * Vuex HMR
 *
 * @see https://vuex.vuejs.org/guide/hot-reload.html#dynamic-module-hot-reloading
 */
if (module.hot) {
    // accept actions and mutations as hot modules
    module.hot.accept([
        '@store/v2',
        // '@store/v2/lib/vuex'
    ], () => {
        // require the updated modules
        // have to add .default here due to babel 6 module output
        // const newMutations = require('./mutations').default
        // const store2 = require('@store/v2').default
        // swap in the new modules and mutations
        store.hotUpdate({
            // mutations: newMutations,
            modules: {
                store2: require('@store/v2').default
                // store2: require('@store/v2/lib/vuex').default
            }
        })
    })
}
// Vue.use(IdleVue, { eventEmitter: new Vue(), idleTime: 30 * 60000, store, startAtIdle: false })
window.$store = store

export default store
